<template>
    <div v-show="show" class="common-popup-bg">
        <div class="common-popup">
            <h3>编辑信息</h3>
            <el-form ref="ruleForm" class="form" :model="form" :rules="rules" size="medium">
                <el-form-item label="用户账号：" prop="username">
                    <span v-text="`${form.username}`"></span>
                </el-form-item>
                <el-form-item label="俱乐部ID：" prop="clubRandomId">
                    <el-input v-model="form.clubRandomId" placeholder="请输入">
                        <el-switch v-model="form.tribeOwner" slot="append" active-text="联盟主号"></el-switch>
                    </el-input>

                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入"/>

                </el-form-item>
                <el-form-item label="联系方式：" prop="contact">
                    <div class="mobile">
                        <el-input v-model="form.mobileAreaCode" placeholder="区号"/>
                        <el-input v-model="form.mobileNo" placeholder="手机号"/>
                    </div>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="form.password" type="password"
                              placeholder="6-16位英文或数字或者“!@#$%^&*.”"/>
                </el-form-item>
                <el-form-item label="密码确认：" prop="repeatPassword">
                    <el-input v-model="form.repeatPassword" type="password" placeholder="请输入"/>
                </el-form-item>
            </el-form>
            <footer>
                <el-button size="small" @click="close('ruleForm')">取消</el-button>
                <el-button size="small" type="danger" @click="deleteFunc('ruleForm')">删除</el-button>
                <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </footer>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            info: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                show: false,
                form: {
                    username: '',
                    clubRandomId: '',
                    tribeOwner:false,
                    remark: '',
                    mobileAreaCode:'',
                    mobileNo: '',
                    password: '',
                    repeatPassword: ''
                },
                rules: {
                    password: [
                        {
                            validator: (rule, value, callback) => {
                                if (value.length && !/^[A-Za-z0-9!@#$%^&*.]{6,16}$/.test(value)) {
                                    callback(new Error('6-16位英文或数字或者“!@#$%^&*.”'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    repeatPassword: [
                        {
                            validator: (rule, value, callback) => {
                                if (value !== this.form.password) {
                                    callback(new Error('两次输入密码不一致!'));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                }
            }
        },
        watch: {
            info(newVal) {
                this.form = {
                    username: newVal.username,
                    clubRandomId: newVal.clubRandomId,
                    tribeOwner:newVal.tribeOwner,
                    remark: newVal.remark,
                    mobileAreaCode:newVal.mobileAreaCode,
                    mobileNo: newVal.mobileNo,
                    password: '',
                    repeatPassword: ''
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = Object.assign({}, this.form, {
                            authTypeCode: this.info.authTypeCode,
                            userId: this.info.id,
                            password: window.btoa(this.form.password),
                            repeatPassword: window.btoa(this.form.repeatPassword)
                        });
                        this.$emit('my-submit', {
                            value: params, cb: () => {
                                this.close(formName)
                            }
                        })
                    } else {
                        return false;
                    }
                });


            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            },
            deleteFunc(formName) {
                this.$confirm(`是否确认删除账号${this.info.username}，删除后该账号创建的子账号将一并删除，请谨慎操作。`, '删除确认', {
                    cancelButtonText: '取消',
                    confirmButtonText: '确认',
                    type: 'warning'
                }).then(() => {
                    this.$emit('my-delete', {
                        id: this.info.id, cb: () => {
                            this.close(formName)
                        }
                    })
                }).catch(() => {

                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        padding-top: 20px;
        :global(.el-input) {
            width: 280px;
        }
        .mobile{
            :global(.el-input:first-of-type) {
                width: 70px;
            }
            :global(.el-input:last-of-type) {
                width: 200px;
                margin-left: 10px;
            }
        }
        :global(.el-form-item) {
            padding: 0 40px 0 30px;
        }
        :global(.el-form-item__label) {
            display: inline-block;
            width: 100px;
        }
        :global(.el-form-item__content) {
            display: inline-block;
        }
    }
</style>